import { getCurrencyFromCountry } from './currencyUtils';

/**
 * Determines the expected currency based on product availability settings and user data.
 *
 * @param {object} formData - The listing form data.
 * @param {Array} addresses - The list of user's available addresses.
 * @param {object} currentUser - The current logged-in user object.
 * @returns {string|null} The determined currency code (e.g., 'USD') or null.
 */
export const determineExpectedCurrency = (formData, addresses, currentUser) => {
  const {
    openToShipping,
    selectedShippingAddressId,
    openToPickUp,
    selectedAddressId,
    productType,
  } = formData;

  const isVirtual = productType === 'virtual';

  // Priority 1: Shipping Address (if shipping is open)
  if (openToShipping && selectedShippingAddressId) {
    const shippingAddr = addresses.find(addr => addr.id === selectedShippingAddressId);
    if (shippingAddr && shippingAddr.country) {
      return getCurrencyFromCountry(shippingAddr.country);
    }
  }

  // Priority 2: Pickup Address (if pickup is open AND shipping is not the determining factor)
  if (openToPickUp && selectedAddressId) {
    const pickupAddr = addresses.find(addr => addr.id === selectedAddressId);
    if (pickupAddr && pickupAddr.country) {
      return getCurrencyFromCountry(pickupAddr.country);
    }
  }

  // Priority 3: Virtual products or no specific address set for active physical methods
  // Fallback to current user's country
  if (isVirtual || ((openToShipping && !selectedShippingAddressId) || (openToPickUp && !selectedAddressId))) {
    if (currentUser && currentUser.country) {
      return getCurrencyFromCountry(currentUser.country);
    }
  }
  
  // If it's not virtual, but neither shipping nor pickup with an address is selected,
  // also fall back to user's country.
  if (!isVirtual && !openToShipping && !openToPickUp) {
      if (currentUser && currentUser.country) {
        return getCurrencyFromCountry(currentUser.country);
    }
  }


  return null; // Default if no currency can be determined
}; 